import { featuredBooks } from '@/mocks/data';

export default function FeaturedBooks() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-12 gap-4">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              编辑精选书单
            </h2>
            <p className="text-foreground-600 text-sm md:text-base">
              每一本都经过精心挑选，只为推荐真正值得花时间品读的好作品
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {featuredBooks.map((book) => (
            <div
              key={book.id}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300"
            >
              <div className="relative overflow-hidden h-56">
                <img
                  src={book.cover}
                  alt={book.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 right-3 bg-accent-500 text-white text-xs font-medium px-2 py-1 rounded-full">
                  {book.rating}
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1">
                  {book.title}
                </h3>
                <p className="text-xs text-foreground-500 mb-2">{book.author} / 著</p>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                  {book.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}